export const ROOM_TYPE_ENUM = {
    // 无导播课堂 simple 智慧教室直播 wisdom 极简教室直播 smallest
    SIMPLE: 'simple', // ROOM_TYPE_ENUM.SIMPLE
    WISDOM: 'wisdom', // ROOM_TYPE_ENUM.WISDOM
    SMALLEST: 'smallest' // ROOM_TYPE_ENUM.SMALLEST
}